import { connect } from 'react-redux';
import * as CreateLabelActions from '../../../store/create-label-content/create-label-content.actions';
import ReturnLabelDispatcher from '../../return-label-dispatcher';

const mapDispatchToProps = (dispatch, { insuranceProviderName, isReturn }) => {
  const labelMetadata = { insuranceProviderName, isReturn };
  return {
    onEmailButtonClicked: (fulfillmentPlanId, doNotPrint, emailAddresses) => {
      dispatch(
        CreateLabelActions.createLabel({
          fulfillmentPlanId,
          doNotPrint,
          returnLabelMetadata: { emailAddresses },
          labelMetadata,
        }),
      );
    },
    onDownloadButtonClicked: (fulfillmentPlanId, doNotPrint) => {
      dispatch(
        CreateLabelActions.createLabel({
          fulfillmentPlanId,
          doNotPrint,
          labelMetadata,
        }),
      );
    },
  };
};

export default connect(null, mapDispatchToProps)(ReturnLabelDispatcher);
